import { render } from "./AccountMenu.vue?vue&type=template&id=47ae8327&ts=true"
import script from "./AccountMenu.vue?vue&type=script&lang=ts&setup=true"
export * from "./AccountMenu.vue?vue&type=script&lang=ts&setup=true"

import "./AccountMenu.vue?vue&type=style&index=0&id=47ae8327&lang=less"

import exportComponent from "/src/PortalSite/Portal/ClientApp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"views/_Layout/AccountMenu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "47ae8327"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('47ae8327', __exports__)) {
    api.reload('47ae8327', __exports__)
  }
  
  module.hot.accept("./AccountMenu.vue?vue&type=template&id=47ae8327&ts=true", () => {
    api.rerender('47ae8327', render)
  })

}


export default __exports__